/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import Flowit from "../services/flowit";
import sessionMonitor from "../services/flowit/sessionMonitor";
import store from "../store";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "dashboard",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/dashboard/Main.vue")
  },
  {
    path: "/profile",
    name: "account",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/my_account/account/Main.vue")
  },
  {
    path: "/team",
    name: "team",
    meta: { requiresAuth: true, layout: "default", capability: "manage_users" },
    component: () => import("../views/Team.vue")
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "clean" },
    component: () => import("../views/Login.vue")
  },
  {
    path: "/reset-password",
    name: "reset-password",
    meta: { layout: "clean" },
    component: () => import("../views/ResetPassword.vue")
  },
  {
    path: "/sales",
    name: "sales",
    meta: { requiresAuth: true, layout: "default", capability: "view_reports" },
    component: () => import("../components/desktop/sales/Main.vue")
  },
  /* {
    path: '/invoices',
    name: 'invoices',
    meta: { requiresAuth: true, layout: 'default' },
    component: () => import('../components/desktop/invoices/Main.vue'),
  }, */
  {
    path: "/invoice/:id",
    name: "invoice",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/Invoice.vue")
  },
  {
    path: "/invoices/new",
    name: "manual",
    meta: { requiresAuth: true, layout: "default", capability: "paylinks" },
    component: () => import("../components/desktop/invoices/NewPayment.vue")
  },
  {
    path: "/internet",
    name: "internet",
    meta: { requiresAuth: true, layout: "default", capability: "paylinks" },
    component: () => import("../components/desktop/invoices/internet/Main.vue")
  },
  {
    path: "/receivables",
    name: "receivables",
    meta: { requiresAuth: true, layout: "default", capability: "view_reports" },
    component: () => import("../components/desktop/receivables/Main.vue")
  },
  {
    path: "/lends",
    name: "lends",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/lends/Main.vue")
  },
  {
    path: "/payment/:id",
    name: "payment",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/Payment.vue")
  },
  {
    path: "/partner_payment/:id",
    name: "partner_payment",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/PartnerPaymentDetails.vue")
  },
  {
    path: "/partners_payments",
    name: "partners_payments",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/PartnersPayments.vue")
  },
  {
    path: "/partners_payments/:id",
    name: "partner_payment_detail",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/PartnerPayment.vue")
  },
  {
    path: "/partner/:id",
    name: "partner",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/Partner.vue")
  },
  {
    path: "/deposits",
    name: "deposits",
    meta: { requiresAuth: true, layout: "default", capability: "view_reports" },
    component: () => import("../views/Deposits.vue")
  },
  {
    path: "/anticipations",
    name: "anticipations",
    meta: { requiresAuth: true, layout: "default", capability: "anticipations" },
    component: () => import("../views/Anticipations.vue")
  },
  {
    path: "/tickets",
    name: "tickets",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/Tickets.vue")
  },
  {
    path: "/ticket/:id",
    name: "ticket",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/TicketRoom.vue")
  },
  {
    path: "/qrcode",
    name: "qrcode",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/my_account/account/Qrcode.vue")
  },
  {
    path: "/taxes",
    name: "taxes",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/my_account/account/Taxes.vue")
  },
  {
    path: "/account/liquidation-account",
    name: "liquidation-account",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/my_account/liquidation_account/Main.vue")
  },
  {
    path: "/wallet",
    name: "wallet",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/wallet/Wallet.vue")
  },
  {
    path: "/recharge-wallet",
    name: "recharge-wallet",
    meta: { requiresAuth: true, layout: "default", capability: "recharge" },
    component: () => import("../views/RechargeWallet.vue")
  },
  {
    path: "/bills/new",
    name: "boleto",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/Bills.vue")
  },
  {
    path: "/bill-payment/:id",
    name: "bill-payment",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/bills/Show.vue")
  },
  {
    path: "/bill-payments",
    name: "bill-payments",
    meta: { requiresAuth: true, layout: "default", capability: "pay_bills" },
    component: () => import("../views/BillPayment.vue")
  },
  {
    path: "/bill-payments/new",
    name: "bill-payments-new",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/BillPayment.vue")
  },
  {
    path: "/bill-payments/:id",
    name: "bill-payments-show",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/bills/ShowBillPayments.vue")
  },
  {
    path: "/darf-payments",
    name: "darf-payments",
    meta: { requiresAuth: true, layout: "default", capability: "pay_bills" },
    component: () => import("../views/DarfPayment.vue")
  },
  {
    path: "/darf-payments/new",
    name: "darf-payments-new",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/DarfPayment.vue")
  },
  {
    path: "/darf-payments/:id",
    name: "darf-payments-show",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/bills/ShowDarfPayments.vue")
  },
  {
    path: "/pix-payments",
    name: "pix-payments",
    meta: { requiresAuth: true, layout: "default", capability: "pay_bills" },
    component: () => import("../views/PixPayment.vue")
  },
  {
    path: "/pix-payments/new",
    name: "pix-payments-new",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/PixPayment.vue")
  },
  {
    path: "/pix-payments/:id",
    name: "pix-payments-show",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/PixPayment.vue")
  },
  {
    path: "/chargebacks",
    name: "chargebacks",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/chargebacks/Main.vue")
  },
  // recharges
  {
    path: "/recharges",
    name: "recharges",
    meta: { requiresAuth: true, layout: "default", capability: "recharge" },
    component: () => import("../components/desktop/recharges/Main.vue")
  },
  {
    path: "/recharges/:id",
    name: "recharges-show",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/recharges/Show.vue")
  },
  // partners
  {
    path: "/partners",
    name: "partners",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/partners/Main.vue")
  },
  // subscriptions
  {
    path: "/invoices/subscription",
    name: "subscriptions",
    meta: { requiresAuth: true, layout: "default", capability: "paylinks" },
    component: () => import("../components/desktop/invoices/subscriptions/Main.vue")
  },
  {
    path: "/subscription/:id",
    name: "subscription",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../views/Subscription.vue")
  },
  {
    path: "/invoices/subscription/new",
    name: "new-subscription",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/invoices/subscriptions/SubscriptionNew.vue")
  },
  {
    path: "/subscription/:id/edit",
    name: "update-subscription",
    meta: { requiresAuth: true, layout: "default" },
    component: () => import("../components/desktop/invoices/subscriptions/SubscriptionUpdate.vue")
  },
  // Public paylink route (no authentication required)
  {
    path: "/paylink/:uuid",
    name: "public-paylink",
    meta: { requiresAuth: false, layout: "clean" },
    component: () => import("../components/paylink/PaymentPage.vue"),
    props: true
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(function(to, from, next) {
  const routeRequiresAuth = to.matched.some(function(matchedRoute) {
    return matchedRoute.meta.requiresAuth;
  });
  
  // Allow public routes without authentication
  if (!routeRequiresAuth) {
    return next();
  }
  
  // Check if token exists and is not expired
  const hasValidToken = Flowit.token.exists();
  
  // If no valid token, redirect to login
  if (routeRequiresAuth && !hasValidToken) {
    console.log('🔐 Authentication required - redirecting to login');
    sessionMonitor.stop(); // Parar monitor se não há token válido
    return next("/login");
  }

  // If token is expired but we have a refresh token, try to refresh
  if (routeRequiresAuth && Flowit.token.isExpired()) {
    const refreshToken = Flowit.token.getRefreshToken();
    if (refreshToken) {
      console.log('🔄 Token expired, attempting refresh...');
      import('../services/flowit/refresh').then(function(refreshModule) {
        return refreshModule.ensureValidToken();
      }).then(function() {
        console.log('✅ Token refreshed successfully');
        sessionMonitor.start(); // Iniciar monitor após refresh bem-sucedido
        next();
      }).catch(function(error) {
        console.error('❌ Token refresh failed:', error);
        Flowit.token.destroy();
        sessionMonitor.stop(); // Parar monitor se refresh falhou
        next("/login");
      });
      return; // Importante: não chamar next() aqui, será chamado no then/catch
    } else {
      console.log('🔐 Token expired and no refresh token - redirecting to login');
      return next("/login");
    }
  }

  // If going to login page but already authenticated, redirect to dashboard
  if (to.path === "/login" && Flowit.token.exists()) {
    sessionMonitor.start(); // Iniciar monitor se usuário já está autenticado
    return next("/");
  }

  // Se chegou até aqui e tem token válido, iniciar monitor
  if (hasValidToken && routeRequiresAuth) {
    sessionMonitor.start();
  }

  // Se indo para login, parar monitor
  if (to.path === "/login") {
    sessionMonitor.stop();
  }

  // Client-portal capability gate: block routes the logged operator can't access.
  // Fails open while the account (and its capabilities) hasn't loaded yet, since
  // the backend still enforces every sensitive action server-side.
  const requiredCapability = to.matched.reduce(function(cap, r) {
    return r.meta && r.meta.capability ? r.meta.capability : cap;
  }, null);
  if (requiredCapability && !store.getters["account/can"](requiredCapability)) {
    return next({ name: "dashboard" });
  }

  return next();
});

export default router;
